import React, {Component} from 'react'
import styles from './ListFeatured.css'
import {defineSwipe, Swipeable} from 'react-touch'
import List from "../List/List"
import {ListLayoutType} from "../../constants/consts-types"
import SliderNavigation from "../SliderNavigation/SliderNavigation"
import {TypeComponentListFeatured, TypeRoute} from "../../constants/consts-prop-types"
import {isDesktop} from "../../services/service-utils"

class ListFeatured extends Component {
  static propTypes = {
    data: TypeComponentListFeatured,
    currentRoute: TypeRoute
  }

  static defaultProps = {
    // numInview: 2.165,
    numInview: 3.25,
  }

  static swipeConfig = defineSwipe({swipeDistance: 50})

  constructor(props) {
    super(props)

    this.state = {
      currentIndex: 0
    }

    this.onSliderNavClick = this.onSliderNavClick.bind(this)
  }

  onSliderNavClick(direction) {
    const {items} = this.props.data

    this.setState(prevState => {
      let nextIndex = prevState.currentIndex + direction

      if (nextIndex < 0) nextIndex = items.length - 1
      if (nextIndex > items.length - 1) nextIndex = 0

      return {
        currentIndex: nextIndex
      }
    })
  }

  render() {
    const headerBold = this.props.currentRoute.title

    const {
      colortheme,
      title,
      items
    } = this.props.data

    if(!items.length || items.length === 0) return null

    const showNavigation = isDesktop() ? items.length > 3 : items.length > 1

    return (
      <section className={colortheme === 'dark' ? styles.ListFeaturedDark : styles.ListFeatured}>
        {title &&
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <h1
                  className={styles.headerBold}
                  dangerouslySetInnerHTML={{__html: headerBold}}
                />
                <h1
                  className={styles.headerLight}
                  dangerouslySetInnerHTML={{__html: title}}
                />

              </div>
            </div>
          </div>
        }

        {showNavigation &&
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <SliderNavigation
                  currentIndex={this.state.currentIndex}
                  numItems={items.length}
                  onSliderNavClick={this.onSliderNavClick}
                />
              </div>
            </div>
          </div>
        }

        <Swipeable
          config={ListFeatured.swipeConfig}
          onSwipeLeft={() => this.onSliderNavClick(1)}
          onSwipeRight={() => this.onSliderNavClick(-1)}
        >
          <div className={styles.list}>
            <List
              listItems={items}
              layout={ListLayoutType.SLIDER}
              numInview={this.props.numInview}
              currentIndex={this.state.currentIndex}
              style={{marginTop: 0}}
            />
            {showNavigation &&
              <button
                onClick={() => this.onSliderNavClick(1)}
                className={styles.buttonNext}
              />
            }
          </div>
        </Swipeable>
      </section>
    );
  }
}

export default ListFeatured;



// WEBPACK FOOTER //
// ./src/components/ListFeatured/ListFeatured.js